import React from 'react';
import { useTranslation } from 'react-i18next';

const DonationAmounts = ({ 
  activeTab, 
  donationOptions, 
  selectedAmount, 
  setSelectedAmount, 
  customAmount, 
  setCustomAmount 
}) => {
  const { t } = useTranslation();

  const titleStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    marginBottom: '0.75rem',
    color: 'var(--primary-color)',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '0.75rem',
    marginBottom: '1rem'
  };

  const getButtonStyle = (isSelected) => ({
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    borderRadius: '0.5rem',
    border: isSelected ? '1px solid var(--primary-color)' : '1px solid #d1d5db',
    backgroundColor: isSelected ? '#eff6ff' : 'white',
    position: 'relative',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out'
  });

  const checkmarkStyle = {
    backgroundColor: 'var(--primary-color)',
    position: 'absolute',
    top: '-0.5rem',
    right: '-0.5rem',
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '0.75rem'
  };

  const inputContainerStyle = {
    display: 'flex',
    border: '1px solid #d1d5db',
    borderRadius: '0.5rem',
    overflow: 'hidden',
    marginBottom: '1.5rem',
    backgroundColor: 'white'
  };

  const dollarPrefixStyle = {
    backgroundColor: '#f3f4f6',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    fontWeight: '600'
  };

  const inputStyle = {
    flex: '1',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    outline: 'none',
    border: 'none',
    backgroundColor: 'white'
  };

  return (
    <div>
      <h3 style={titleStyle}>
        {activeTab === 'once'
          ? t('autoAjr.selectDonationAmount')
          : t('autoAjr.selectWeeklyDonationAmount')}
      </h3>
      <div className="mb-3"><div className="panels-section" style={gridStyle}>
            {donationOptions[activeTab].map((amount) => (
              <div
                key={amount}
                className={`panel ${selectedAmount[activeTab] === amount && !customAmount[activeTab] ? 'selected' : ''}`}
                onClick={() => {
                  setSelectedAmount({
                    ...selectedAmount,
                    [activeTab]: amount
                  });
                  setCustomAmount({
                    ...customAmount,
                    [activeTab]: ''
                  });
                }}
              >
                <h3>{amount}</h3>
              </div>
            ))}
          </div></div>
      
      {/* <div style={gridStyle}>
        {donationOptions[activeTab].map((amount) => (
          <button
            type="button"
            key={amount}
            style={getButtonStyle(selectedAmount[activeTab] === amount && !customAmount[activeTab])}
            onMouseEnter={(e) => {
              if (!(selectedAmount[activeTab] === amount && !customAmount[activeTab])) {
                e.currentTarget.style.borderColor = 'var(--primary-color)';
                e.currentTarget.style.backgroundColor = '#eff6ff';
              }
            }}
            onMouseLeave={(e) => {
              if (!(selectedAmount[activeTab] === amount && !customAmount[activeTab])) {
                e.currentTarget.style.borderColor = '#d1d5db';
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
            onClick={() => {
              setSelectedAmount({
                ...selectedAmount,
                [activeTab]: amount
              });
              setCustomAmount({
                ...customAmount,
                [activeTab]: ''
              });
            }}
          >
            £{amount}
            {(selectedAmount[activeTab] === amount && !customAmount[activeTab]) ? (
              <div style={checkmarkStyle}>
                ✓
              </div>
            ) : null}
          </button>
        ))}
      </div> */}
      <div style={inputContainerStyle}>
        <div style={dollarPrefixStyle}>£</div>
        <input
          type="number"
          style={inputStyle}
          className="custom-amount-input"
          placeholder={t('autoAjr.enterCustomAmount')}
          value={customAmount[activeTab]}
          onChange={(e) => {
            setCustomAmount({
              ...customAmount,
              [activeTab]: e.target.value
            });
          }}
          min={activeTab === 'weekly' ? 3 : 1}
        />
      </div>
    </div>
  );
};

export default DonationAmounts;